const update = require('immutability-helper')

const mapPropertiesToMutateObject = require('./utils/mapPropertiesToMutateObject')
const { pageView, component, object, user, basic } = require('./default-properties')

const defaultProperties = {
  ...pageView,
  ...component,
  ...object,
  ...user,
  ...basic,
};

function impressionProperties(properties = {}, globalProperties = {}) {
  const propertiesToMutate = mapPropertiesToMutateObject(properties, globalProperties)
  return update(defaultProperties, propertiesToMutate)
};

function validate() {
  // Event data validation
}

module.exports = {
  impressionProperties,
  validate,
}